import { createFileRoute } from '@tanstack/react-router';
import { CountPage } from '@/features/inventory/CountsPage';
export const Route = createFileRoute('/_dashboard/dashboard/inventory/counts/$countId')({
  component: Page,
});
function Page() {
  const { countId } = Route.useParams();
  return <CountPage countId={countId} />;
}
